"use client";

import MainLayout from "@/components/layout/main-layout";
import { fireUserEngagementEvent } from "@/libs/utils";
import Image from "next/image";
// import Link from "next/link";
import { useState } from "react";

export default function NRTPage() {
  // State to track which blog posts are expanded
  const [expandedPosts, setExpandedPosts] = useState<number[]>([]);

  // Function to toggle post expansion
  const togglePostExpansion = (postId: number) => {
    setExpandedPosts((prev) =>
      prev.includes(postId)
        ? prev.filter((id) => id !== postId)
        : [...prev, postId]
    );
  };

  // Check if a post is expanded
  const isPostExpanded = (postId: number) => expandedPosts.includes(postId);
  // Blog post data
  const blogPosts = [
    {
      id: 1,
      date: "December 20, 2024",
      title:
        "Nicotine Gum vs. Patches vs. Lozenges: Which NRT is Best for Your Quit Journey",
      excerpt:
        "Deciding that you want to quit your habit of smoking is the first step towards an improved and healthier life. However, nicotine addiction is one of the hardest habits...",
      fullContent:
        "Deciding that you want to quit your habit of smoking is the first step towards an improved and healthier life. However, nicotine addiction is one of the hardest habits to break. Nicotine Replacement Therapy (NRT) products can significantly increase your chances of quitting successfully by reducing withdrawal symptoms and cravings. But with several options available—gums, patches, lozenges, and more—how do you know which one is right for you? This comprehensive guide compares the most popular NRT products to help you make an informed decision for your quit journey.\n\nNicotine gum provides fast-acting relief when cravings hit, while patches offer consistent nicotine delivery throughout the day. Lozenges dissolve slowly in your mouth, providing a middle ground between the immediate relief of gum and the steady delivery of patches. Your personal preferences, smoking habits, and lifestyle should guide your choice. Some people even find that combining different NRT products (like using a patch for baseline nicotine and gum for breakthrough cravings) works best for them.",
      image: "https://ext.same-assets.com/3308585408/3201841861.png",
      slug: "nicotine-gum-vs-patches-vs-lozenges-which-nrt-is-best-for-your-quit-journey",
    },
    {
      id: 2,
      date: "November 15, 2024",
      title: "How to Use Nicotine Replacement Therapy Effectively",
      excerpt:
        "Nicotine Replacement Therapy (NRT) can double your chances of quitting smoking successfully, but only if used correctly. Learn the proper techniques for using different NRT products...",
      fullContent:
        "Nicotine Replacement Therapy (NRT) can double your chances of quitting smoking successfully, but only if used correctly. Learn the proper techniques for using different NRT products to maximize their effectiveness and minimize side effects. For nicotine gum, the 'chew and park' method is essential—chew until you feel a tingling sensation, then park the gum between your cheek and gum. With patches, proper skin preparation and rotation of application sites can prevent skin irritation. Lozenges should be allowed to dissolve slowly without chewing or swallowing. Timing is also crucial—start using NRT on your quit date, not before or after. Most people don't use NRT long enough, so follow the recommended treatment duration, typically 8-12 weeks, gradually reducing the dosage as your body adjusts to lower nicotine levels.",
      image: "https://ext.same-assets.com/3308585408/1532772535.png",
      slug: "how-to-use-nicotine-replacement-therapy-effectively",
    },
    {
      id: 3,
      date: "October 5, 2024",
      title: "Common Side Effects of NRT and How to Manage Them",
      excerpt:
        "While Nicotine Replacement Therapy is generally safe, some users experience side effects. This article covers the most common side effects and provides practical advice on how to manage them...",
      fullContent:
        "While Nicotine Replacement Therapy is generally safe, some users experience side effects. This article covers the most common side effects and provides practical advice on how to manage them effectively. Nicotine gum may cause jaw soreness, hiccups, or an upset stomach. To minimize these effects, use the proper chewing technique and avoid chewing too vigorously. Patches can cause skin irritation—clean the area before application, rotate sites daily, and consider hypoallergenic options if needed. Lozenges might cause hiccups, heartburn, or nausea, which can often be reduced by using them correctly (letting them dissolve slowly) and not using them on an empty stomach. Remember that NRT side effects are usually mild and temporary, especially compared to the health risks of continued smoking. If side effects persist or are severe, consult your healthcare provider about adjusting your dosage or trying a different form of NRT.",
      image: "https://ext.same-assets.com/3308585408/2013060688.png",
      slug: "common-side-effects-of-nrt-and-how-to-manage-them",
    },
    {
      id: 4,
      date: "September 18, 2024",
      title: "Combining Different NRT Products: Is it Safe and Effective?",
      excerpt:
        "Research suggests that combining different forms of Nicotine Replacement Therapy can be more effective than using a single product. Learn about safe combinations and how to use them...",
      fullContent:
        "Research suggests that combining different forms of Nicotine Replacement Therapy can be more effective than using a single product. Learn about safe combinations and how to use them for maximum benefit. The most common and effective combination is using a long-acting product (like the patch) for baseline nicotine levels, supplemented with a short-acting product (like gum, lozenges, or inhalers) for breakthrough cravings. This approach, sometimes called 'combination therapy' or 'dual NRT,' has been shown in clinical studies to increase quit rates by up to 25% compared to single NRT use. When combining products, it's important to monitor your total nicotine intake to avoid overdose symptoms like nausea, headaches, or rapid heartbeat. Start with lower doses of each product and adjust as needed. Always consult with a healthcare provider before starting combination therapy, especially if you have underlying health conditions.",
      image: "https://ext.same-assets.com/3308585408/1157903761.png",
      slug: "combining-different-nrt-products-is-it-safe-and-effective",
    },
    {
      id: 5,
      date: "August 30, 2024",
      title: "NRT and Mental Health: Managing Anxiety During Smoking Cessation",
      excerpt:
        "Quitting smoking can temporarily worsen anxiety and other mental health symptoms. Discover how NRT can help manage these symptoms and support your mental wellbeing during the quit process...",
      fullContent:
        "Quitting smoking can temporarily worsen anxiety and other mental health symptoms. Discover how NRT can help manage these symptoms and support your mental wellbeing during the quit process. Many smokers use nicotine as a form of self-medication for anxiety, stress, or depression. When you quit, the withdrawal of nicotine can temporarily exacerbate these conditions. NRT can help by providing controlled amounts of nicotine without the harmful chemicals in cigarettes, allowing your brain chemistry to adjust gradually rather than abruptly. This gradual approach can significantly reduce anxiety and mood disturbances during the quit process. Beyond NRT, complementary strategies like mindfulness meditation, regular physical exercise, and cognitive-behavioral techniques can further support your mental health while quitting. If you have a diagnosed mental health condition, work closely with your healthcare provider to monitor your symptoms and adjust your treatment plan as needed during smoking cessation.",
      image: "https://ext.same-assets.com/3308585408/582052338.svg",
      slug: "nrt-and-mental-health-managing-anxiety-during-smoking-cessation",
    },
    {
      id: 6,
      date: "July 22, 2024",
      title: "The Science Behind Nicotine Replacement Therapy",
      excerpt:
        "Understanding how NRT works in your body can help you use it more effectively. This article explains the science of nicotine addiction and how replacement therapies help break the cycle...",
      fullContent:
        "Understanding how NRT works in your body can help you use it more effectively. This article explains the science of nicotine addiction and how replacement therapies help break the cycle. Nicotine is a highly addictive substance that binds to receptors in your brain, triggering the release of dopamine and other neurotransmitters that create feelings of pleasure and alertness. When you smoke, nicotine reaches your brain within seconds, creating a powerful reinforcement loop. Over time, your brain develops more nicotine receptors, increasing your dependence. When you quit smoking abruptly, the sudden absence of nicotine leads to withdrawal symptoms as your brain chemistry struggles to rebalance. NRT works by providing controlled amounts of nicotine through alternative delivery methods, satisfying your brain's nicotine receptors without the harmful chemicals in tobacco smoke. This allows you to break the behavioral aspects of smoking while gradually reducing your nicotine intake, giving your brain time to reduce the number of nicotine receptors and adapt to functioning with less and eventually no nicotine.",
      image: "https://ext.same-assets.com/3308585408/1658428856.svg",
      slug: "the-science-behind-nicotine-replacement-therapy",
    },
  ];

  // Trending posts data
  const trendingPosts = [
    {
      id: 1,
      title: "सामान्य निकासी के लक्षण: अवधि, टिप्स, रोकथाम",
      date: "July 22, 2024",
      image: "https://ext.same-assets.com/3308585408/3201841861.png",
      slug: "common-withdrawal-symptoms-duration-tips-prevention",
    },
    {
      id: 2,
      title: "10 Tips to Stay Smoke-Free After Using NRT",
      date: "June 15, 2024",
      image: "https://ext.same-assets.com/3308585408/1532772535.png",
      slug: "10-tips-to-stay-smoke-free-after-using-nrt",
    },
    {
      id: 3,
      title: "NRT Success Stories: Real People, Real Results",
      date: "May 8, 2024",
      image: "https://ext.same-assets.com/3308585408/2013060688.png",
      slug: "nrt-success-stories-real-people-real-results",
    },
  ];

  return (
    <MainLayout>
      {/* Hero Section */}
      <section className="bg-background pt-12 pb-8">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-medium text-secondary mb-4">
            Nicotine Replacement Therapy (NRT)
          </h1>
          <p className="text-secondary/80 max-w-3xl">
            Explore our collection of articles about Nicotine Replacement
            Therapy (NRT) to help you understand the different options
            available, how to use them effectively, and how they can support
            your journey to quit smoking or tobacco use.
          </p>
        </div>
      </section>

      {/* Blog Content Section */}
      <section className="py-8 bg-background">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Blog Posts */}
            <div className="lg:col-span-2">
              {blogPosts.map((post) => (
                <div
                  key={post.id}
                  className="mb-12 border-b border-gray-200 pb-8"
                >
                  <div className="text-sm text-secondary/70 mb-2">
                    {post.date}
                  </div>
                  <h2 className="text-2xl font-medium text-secondary mb-3">
                    <span className="hover:text-primary transition-colors">
                      {post.title}
                    </span>
                  </h2>
                  <p className="text-secondary/80 mb-4">
                    {isPostExpanded(post.id) ? post.fullContent : post.excerpt}
                  </p>
                  <button
                    id="toggle-post-expansion"
                    aria-expanded={isPostExpanded(post.id)}
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      togglePostExpansion(post.id);
                      fireUserEngagementEvent();
                    }}
                    className="text-primary font-medium hover:underline mb-6 inline-block"
                  >
                    {isPostExpanded(post.id) ? "Read Less" : "Read More"}
                  </button>
                  {post.id === 1 && (
                    <div className="mt-4 relative w-full h-[400px] rounded-lg overflow-hidden">
                      <Image
                        src={post.image}
                        alt={post.title}
                        fill
                        style={{ objectFit: "cover" }}
                        className="rounded-lg"
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Sidebar - Trending Posts */}
            <div className="lg:col-span-1">
              <div className="bg-primary/5 p-6 rounded-lg">
                <h3 className="text-xl font-medium text-secondary mb-6">
                  Trending this week
                </h3>

                <div className="space-y-6">
                  {trendingPosts.map((post) => (
                    <div key={post.id} className="flex flex-col">
                      <div className="relative w-full h-40 mb-3 rounded-lg overflow-hidden">
                        <Image
                          src={post.image}
                          alt={post.title}
                          fill
                          style={{ objectFit: "cover" }}
                          className="rounded-lg"
                        />
                      </div>
                      <h4 className="text-lg font-medium text-secondary mb-1">
                        <span className="hover:text-primary transition-colors">
                          {post.title}
                        </span>
                      </h4>
                      <div className="text-sm text-secondary/70">
                        {post.date}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MainLayout>
  );
}
